import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Platform } from 'react-native';

export function CardBgColorPicker({ swatches = [], selectedColor, accentColor, onSelectColor }) {
  const pickerHex =
    selectedColor && /^#[0-9a-fA-F]{6}$/i.test(selectedColor) ? selectedColor : '#1075ae';

  return (
    <View>
      <View style={styles.swatchGrid}>
        {swatches.map((color) => (
          <TouchableOpacity
            key={color}
            style={[
              styles.bgSwatch,
              { backgroundColor: color },
              selectedColor === color && [styles.bgSwatchActive, { borderColor: accentColor }],
              color === '#ffffff' && { borderWidth: 1, borderColor: '#ddd' },
            ]}
            onPress={() => onSelectColor(color)}
            accessibilityLabel={`Background color ${color}`}
          />
        ))}
      </View>
      {Platform.OS === 'web' ? (
        <View style={styles.pickerRow}>
          <Text style={styles.pickerLabel}>Custom color</Text>
          <View style={styles.pickerControl}>
            <input
              type="color"
              value={pickerHex}
              onChange={(e) => onSelectColor(e.target.value)}
              aria-label="Pick a custom background color"
              style={{
                width: 44,
                height: 44,
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                padding: 0,
                background: 'transparent',
              }}
            />
            <Text style={styles.pickerHex}>{pickerHex.toUpperCase()}</Text>
          </View>
        </View>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  swatchGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: 8, marginBottom: 10 },
  bgSwatch: { width: 32, height: 32, borderRadius: 16 },
  bgSwatchActive: { borderWidth: 3 },
  pickerRow: { gap: 6 },
  pickerLabel: { fontFamily: 'VastagoGrotesk', fontSize: 12, color: '#555' },
  pickerControl: { flexDirection: 'row', alignItems: 'center', gap: 10, marginTop: 4 },
  pickerHex: { fontFamily: 'VastagoGrotesk', fontSize: 13, color: '#333', letterSpacing: 0.5 },
});
